import { useQuery } from 'react-query';
import useContext from '../../hooks/useContext';
import { SiteContext } from '../../SiteContext';
import { get } from '../fetch';
import { appendPreviewDate } from '../helper';

export const useSearchCompletionQuery = (query: string) => {
  const {
    data: { searchServiceUrl },
  } = useContext(SiteContext);
  const url = appendPreviewDate(`${searchServiceUrl}/search/completion/?search=${query}`);

  return useQuery(['completion', query], () => get<ICompletion[]>(url), {
    enabled: !!query,
  });
};
